import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { RefreshService } from './refresh.service';

@Injectable({ providedIn: 'root' })
export class WebBridgeService implements OnDestroy {
    private listener = (evt: MessageEvent) => this.onMessage(evt);

    constructor(private ngZone: NgZone, private refreshService: RefreshService) {
        window.addEventListener('message', this.listener);
    }

    private async onMessage(evt: MessageEvent) {
        let data: any;
        try {
            data = typeof evt.data === 'string' ? JSON.parse(evt.data) : evt.data;
        } catch {
            return;
        }
        if (!data || !data.type) return;


        if (data.type === 'RN_INTERCEPTED_BLOB' && data.url) {
            this.handleInterceptedBlob(data).catch(err => {
                console.error('[WebBridge] handleInterceptedBlob error', err);
                this.postToNative({
                    type: 'RN_SEND_BASE64',
                    url: data.url,
                    error: String(err)
                });
            });
            return;
        }

        this.ngZone.run(async () => {
            try {
                if (data.type === 'RN_REQUEST_SOFT_REFRESH') {
                    try {
                        await this.refreshService.refreshAll();
                        this.postToNative({ type: 'ANGULAR_REFRESH_DONE' });
                    } catch (e) {
                        console.error('[WebBridge] refresh failed', e);
                        this.postToNative({ type: 'ANGULAR_REFRESH_FAILED', payload: { error: String(e) } });
                    }
                }
                // puedes añadir aquí más handlers que deban ejecutarse dentro del Angular zone
            } catch (err) {
                console.error('[WebBridge] onMessage (ngZone) error', err);
            }
        });
    }


    private async handleInterceptedBlob(data: { url: string; filename?: string;[k: string]: any }) {
        const url = data.url;
        const filename = data.filename || 'document.pdf';

        if (url.startsWith('data:')) {
            this.postToNative({
                type: 'RN_SEND_BASE64',
                url,
                base64: url,
                filename
            });
            return;
        }

        const resp = await fetch(url);
        if (!resp.ok) throw new Error('fetch failed status=' + resp.status);
        const blob = await resp.blob();
        const dataUri = await this.blobToDataURI(blob);
        this.postToNative({
            type: 'RN_SEND_BASE64',
            url,
            base64: dataUri,
            filename
        });
    }

    private blobToDataURI(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            try {
                const reader = new FileReader();
                reader.onerror = (ev) => {
                    reject(new Error('FileReader error'));
                };
                reader.onload = () => {
                    const result = reader.result as string; // data:...;base64,...
                    resolve(result);
                };
                reader.readAsDataURL(blob);
            } catch (err) {
                reject(err);
            }
        });
    }

    private postToNative(msg: any) {
        try {
            const payload = JSON.stringify(msg);
            if ((window as any).ReactNativeWebView?.postMessage) {
                (window as any).ReactNativeWebView.postMessage(payload);
            } else {
                window.dispatchEvent(new MessageEvent('message', { data: payload }));
                console.debug('[WebBridge] fallback dispatch message to window:', msg);
            }
        } catch (err) {
            console.error('[WebBridge] postToNative error', err);
        }
    }

    ngOnDestroy() {
        window.removeEventListener('message', this.listener);
    }
}
